import { FaRegStar, FaStar } from "react-icons/fa6";

const MAX_STARS = 5; // Nombre maximum d'étoiles

const StarRating = ({ rating, onRatingChange }: any) => {
  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= MAX_STARS; i++) {
      stars.push(
        <span
          key={i}
          onClick={() => onRatingChange(i)} // Utilise onClick pour le web
          style={{ cursor: 'pointer', display: 'inline-block' }} // Ajoute un curseur pointeur pour indiquer l'interactivité
        >
          {/* Rendre FaStar pour une étoile pleine, FaRegStar pour une étoile vide */}
          {i <= rating ? (
            <FaStar
              size={30}
              color="#FFD700" // Jaune pour les étoiles sélectionnées
              style={{ margin: '0 2px' }} // Style en ligne pour la marge horizontale
            />
          ) : (
            <FaRegStar
              size={30}
              color="#CCCCCC" // Gris pour les étoiles vides
              style={{ margin: '0 2px' }} // Style en ligne pour la marge horizontale
            />
          )}
        </span>
      );
    }
    return stars;
  };

  return (
    <div
      style={{
        display: 'flex', // Remplace flexDirection: 'row'
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {renderStars()}
    </div>
  );
};

export default StarRating;

// const StarRating = ({ rating, onRatingChange }: any) => {
//   const renderStars = () => {
//     const stars = [];
//     for (let i = 1; i <= MAX_STARS; i++) {
//       stars.push(
//         <TouchableOpacity
//           key={i}
//           onPress={() => onRatingChange(i)} // Quand on clique, on passe la valeur de l'étoile
//           activeOpacity={0.7}
//         >
//           <Icon
//             name={i <= rating ? 'star' : 'star-o'} // 'star' pour étoile pleine, 'star-o' pour étoile vide (FontAwesome)
//             size={30}
//             color={i <= rating ? '#FFD700' : '#CCCCCC'} // Jaune pour les étoiles sélectionnées, gris pour les vides
//             style={styles.star}
//           />
//         </TouchableOpacity>
//       );
//     }
//     return stars;
//   };

//   return <View style={styles.container}>{renderStars()}</View>;
// };

// const styles = StyleSheet.create({
//   container: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   star: {
//     marginHorizontal: 2,
//   },
// });

// export default StarRating;